import { createStyles } from '@mantine/core';
import { getTypographyStyles } from 'src/theme/themeConfig';

export const useStyles = createStyles(() => ({
  modalContentWrapper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    textAlign: 'center',
  },
  subtext: {
    marginTop: '8px',
    ...getTypographyStyles('content_sm_regular'),
  },
  modalBtnContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '0px 24px',
    gap: '8px',
  },
  modalBtn: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    padding: '12px 16px',
    gap: '10px',
    color: '#000000',
    borderRadius: '24px',
    fontSize: '14px',
    fontWeight: 500,
    border: 'none',
    background: '#ffffff',
    outline: 'none',
  },
}));

export default useStyles;
